import React from 'react';
import { Button, ButtonGroup, Box } from '@mui/material';

const TimeRangeSelector = ({ setFrom, setTo, formatForState }) => {
  const now = new Date();

  const setRange = (fromDate, toDate = now) => {
    setFrom(formatForState(fromDate));
    setTo(formatForState(toDate));
  };

  const handleLast365 = () => {
    const start = new Date();
    start.setDate(now.getDate() - 365);
    setRange(start);
  };

  const handleLast30 = () => {
    const start = new Date();
    start.setDate(now.getDate() - 30);
    setRange(start);
  };

  const handleLast7 = () => {
    const start = new Date();
    start.setDate(now.getDate() - 7);
    setRange(start);
  };

  const handleYesterday = () => {
    const start = new Date();
    start.setDate(now.getDate() - 1);
    start.setHours(0, 0, 0, 0);
    const end = new Date();
    end.setDate(now.getDate() - 1);
    end.setHours(23, 59, 59, 999);
    setRange(start, end);
  };

  const handleToday = () => {
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    const end = new Date();
    end.setHours(23, 59, 59, 999);
    setRange(start, end);
  };

  return (
    
      <ButtonGroup variant="outlined" size="small">
        <Button onClick={handleToday}>Heute</Button>
        <Button onClick={handleYesterday}>Gestern</Button>
        <Button onClick={handleLast7}>Letzte 7 Tage</Button>
        <Button onClick={handleLast30}>Letze 30 Tage</Button>
        <Button onClick={handleLast365}>Letzte 365 Tage</Button>
      </ButtonGroup>
    
  );
};

export default TimeRangeSelector;
